<template>

  <data-form
    :entity="formModel"
    :fields="fields"
    @change="onChange"
    @submit="onSubmit"
    :cancel="false"
  />

</template>

<script>
import { post } from 'providers/http'

export default {
  name: 'network-connection',
  data () {
    return {
      formModel: {
        networkType: 'wifi'
      }
    }
  },
  computed: {
    fields () {
      let fields = {
        'networkType': {
          type: 'radio',
          options: [
            {
              value: 'wifi',
              label: 'networkType.wifi'
            },
            {
              value: 'cable',
              label: 'networkType.cable'
            }
          ]
        },
        'ssid': {
          hidden: this.formModel.networkType === 'cable',
          rules: [{ required: true }]
        },
        'secuType': {
          hidden: this.formModel.networkType === 'cable',
          type: 'select',
          options: [
            {
              value: 1,
              label: 'secType.none'
            },
            {
              value: 2,
              label: 'secType.WEP'
            },
            {
              value: 3,
              label: 'secType.WPA'
            },
            {
              value: 4,
              label: 'secType.WPA2'
            }
          ]
        },
        'secuPassphrase': {
          hidden: this.formModel.networkType === 'cable',
          type: 'password',
          rules: [{ required: true }]
        }
      }

      return fields
    }
  },
  methods: {
    onChange (formModel) {
      this.formModel = formModel
    },
    async onSubmit (formModel) {
      try {
        await post('api/v1/servers/set-network-connetion', formModel)
        this.$emit('next')
      }
      catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// NetworkConnection.vue?3a2d2a27